import React from 'react'

import { UISizes } from 'components/utils/UiConfig'
import { rem } from 'polished'
import styled, { css, SimpleInterpolation } from 'styled-components'
import switchFunc from 'lib/switchFunc'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  equal?: boolean;
  size?: UISizes;
  spacing?: UISizes;
  wraps?: boolean;
  as?: keyof JSX.IntrinsicElements;
  vertical?: 'center' | 'start' | 'end' | 'baseline' | 'stretch';
  horizontal?: 'center' | 'start' | 'end' | 'around' | 'between' | 'evenly';
}

const spacing = switchFunc<SimpleInterpolation, UISizes>({
  xs: css`
    gap: ${rem(4)};
  `,
  sm: css`
    gap: ${rem(8)};
    `,
  md: css`
    gap: ${rem(12)};
  `,
  lg: css`
    gap: ${rem(16)};
  `,
  xl: css`
    gap: ${rem(20)};
  `,
  xxl: css`
    gap: ${rem(32)};
  `,
})

const Root = styled.div<Props>`
  display: flex;

  ${({ wraps }) => wraps && 'flex-wrap: wrap;'}
  ${({ size }) => size && spacing(size)}
  ${({ spacing: spacingProp }) => spacingProp && spacing(spacingProp)}

  ${({ equal }) => equal && css`
    & > * {
      flex: 1;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        flex-basis: 100%;
      }
    }
  `}

  ${({ vertical }) => (vertical === 'center' && 'align-items: center;') ||
    (vertical === 'start' && 'align-items: flex-start;') ||
    (vertical === 'end' && 'align-items: flex-end;') ||
    (vertical === 'baseline' && 'align-items: baseline;') ||
    (vertical === 'stretch' && 'align-items: stretch;')}

  ${({ horizontal }) => (horizontal === 'center' && 'justify-content: center;') ||
    (horizontal === 'start' && 'justify-content: flex-start;') ||
    (horizontal === 'end' && 'justify-content: flex-end;') ||
    (horizontal === 'around' && 'justify-content: space-around;') ||
    (horizontal === 'between' && 'justify-content: space-between;') ||
    (horizontal === 'evenly' && 'justify-content: space-evenly;')}
`

function InlineGroup(props: Props, ref: React.Ref<HTMLElement>) {
  return (
    <Root ref={ref} {...props} />
  )
}

/**
  * @deprecated
  * Use `<Group>` instead
  */
export default React.forwardRef(InlineGroup)
